module.exports = __webpack_public_path__ + "static/media/ai-ml.d1fe0270.png";